import BSearch from './BSearch';
export default BSearch;
